import React, { useState } from 'react';
import { Typography } from '@mui/material';

import {
  BackdropForDialog,
  CloseButton,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  SubmitButton,
} from 'components';
import { ZoneForm } from 'forms';
import { useZone } from 'pages/zones/zones.hook';

interface ZoneCopyDialogProps {
  visible?: boolean;
  setVisible?: (value: boolean) => void;
  title?: string;
  submitButtonLabel?: string;
  zoneId: number;
}

export const ZoneCopyDialog = ({
  visible = false,
  setVisible = () => {},
  title = 'Copy Zone',
  submitButtonLabel = 'Copy',
  zoneId,
}: ZoneCopyDialogProps) => {
  const [loading_form, setLoadingForm] = useState<boolean>(false);
  const [loading_submit, setLoadingSubmit] = useState<boolean>(false);
  const [loading_zone, zone] = useZone({ zoneId });

  const formRef = React.useRef<any>();

  const onClose = (event: any, reason: string) => {
    if (reason !== 'backdropClick' && reason !== 'escapeKeyDown') {
      setVisible(false);
      document.body.removeAttribute('style');
    }
  };

  const onSubmit = () => {
    formRef.current.onSubmit();
  };

  return (
    <Dialog open={visible} onClose={onClose}>
      <DialogTitle>
        <Typography variant="h5" component="span">
          {title}
        </Typography>
      </DialogTitle>

      <DialogContent>
        <ZoneForm
          ref={formRef}
          zoneId={zoneId}
          initialBuildingId={zone?.building_id}
          onInit={(loading) => setLoadingForm(loading)}
          onSubmitting={(loading) => setLoadingSubmit(loading)}
          next={() => {
            setVisible(false);
          }}
          isCopy
        />
      </DialogContent>

      <DialogActions>
        <SubmitButton loading={loading_submit} label={submitButtonLabel} onClick={onSubmit} />
      </DialogActions>

      <CloseButton onClick={() => onClose(null, 'anyway')} sx={{ zIndex: (theme) => theme.zIndex.modal + 1 }} />

      <BackdropForDialog loading={loading_form || loading_zone} />
    </Dialog>
  );
};
